export default "__VITE_ASSET__3468ee2b__"